import axios from "axios";
const baseurl = process.env.REACT_APP_API_URL;

export const addProducttoWishlist = async (data, token) => {
  try {
    const res = await axios({
      method: "post",
      url: baseurl + `/addBookmark`,
      headers: {
        token: token,
      },
      data: { productId: data },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const getWishlistProducts = async (token, pagenum, productsNum) => {
  try {
    const res = await axios({
      method: "get",
      url: baseurl + `/getBookmark?page=${pagenum}&limit=${productsNum}`,
      headers: {
        token: `${token}`,
      },
    });
    return res.data.data?.products;
  } catch (error) {
    console.log(error);
  }
};
